import { PlayerColor } from 'features/board/board'
import { finishGameByDraw } from 'features/firebase/game-operations'
import { useGameEvents } from 'features/firebase/use-game-events'

import { useGameContext } from './game-context'

export const useDrawAction = () => {
  const { dispatchDrawEvent } = useGameEvents()
  const {
    game,
    relativeGameData: { playerColor },
  } = useGameContext()

  let playerRequestingDraw: false | PlayerColor = false
  const lastEvent = game.events.length ? game.events[game.events.length - 1] : null
  if (
    lastEvent &&
    lastEvent.type === 'draw' &&
    lastEvent.metadata.eventCode === 'request' &&
    lastEvent.metadata.player === playerColor.top
  ) {
    playerRequestingDraw = playerColor.top
  }

  const requestDraw = () => dispatchDrawEvent({ eventCode: 'request', player: playerColor.bottom })
  const rejectDraw = () => dispatchDrawEvent({ eventCode: 'reject', player: playerColor.bottom })
  const acceptDraw = () => {
    dispatchDrawEvent({ eventCode: 'accept', player: playerColor.bottom })
    finishGameByDraw(game.gameId)
  }

  return { playerRequestingDraw, requestDraw, rejectDraw, acceptDraw }
}
